import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "screens/style";
import checkEmail from "assets/icons/checkEmail.jpg";
import { sectionBackgroundStyles } from "screens/sectionBackgroundStyles";
import { styleSizes } from "constants/styleSizes";

export const CheckOutConfirmScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .background {
    ${sectionBackgroundStyles}
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: none;
    }
  }

  .innerContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      padding: 0;
    }
  }

  .titleContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 65px 20px;

    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      padding: 48px 20px;
    }

    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      justify-content: left;
    }

    .checkEmailImage {
      width: 368px;
      height: 254px;
      background-image: url(${checkEmail});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-bottom: 20px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        width: 327px;
        height: 225px;
      }
    }

    .titleHighlight {
      text-align: center;
      font-size: 32px;
      font-weight: 600;
      color: ${colors.almostBlack};
      margin-bottom: 16px;
      margin-top: 8px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        text-align: left;
        font-size: 24px;
        font-weight: 600;
      }

    }

    .subtitle {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: ${colors.almostBlack};
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        text-align: left;
        font-weight: 400;
      }
    }
  }

  .changeEmailContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: ${colors.backgroundGreen};
    padding: 64px 20px 64px 20px;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      padding: 48px 20px 48px 20px;
    }

    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      padding: 32px 20px 16px 20px;
    }

    .title {
      width: 100%;
      text-align: center;
      font-size: 34px;
      font-weight: 600;
      color: ${colors.white};
      margin-bottom: 32px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      font-size: 24px;
      text-align: left;
      margin-bottom: 16px;
    }
    }

    .description {
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: ${colors.white};
      margin-bottom: 18px;
      line-height: 24px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      font-size: 16px;
      text-align: left;
    }
    }
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 10px 0;

  .row {
    display: flex;
    width: 100%;
    max-width: 450px;
    height: 50px;
    min-width: 300px;
    column-gap: 10px;
    padding: 0 20px;
    margin-bottom: 16px;
  }
`;
